// src/pages/Coaches.jsx
import React from 'react';

const Coaches = () => (
  <div className="min-h-screen flex items-center justify-center p-6">
    <div className="bg-white bg-opacity-80 rounded-lg p-8 shadow-lg text-center border border-gray-300">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">المدربون</h2>
      <p className="text-lg text-gray-600">لا توجد قائمة المدربين حاليا</p>
    </div>
  </div>
);

export default Coaches;
